import '/vercel/path0/docs/demo/ant-design.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"ant-design","toc":"menu","filename":"docs/demo/ant-design.md","lastUpdated":1780642515000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-ant-design-demo-ant-design"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/ant-design.md?type=demo')
};